import { LogOut, ParkingSquare } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { NotificationsBell } from "./NotificationsBell";
import { ActiveReservation } from "./ActiveReservation";

export const Header = () => {
  const { user, logout } = useAuth();
  return (
    <header data-testid="app-header" className="sticky top-0 z-[1000] bg-stone-900/85 backdrop-blur-md border-b border-amber-500/20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center gap-3">
        <div className="h-10 w-10 rounded-xl bg-[#E0533C] grid place-items-center shrink-0 -rotate-3">
          <ParkingSquare className="h-6 w-6 text-white" />
        </div>
        <div className="min-w-0 flex-1">
          <h1 data-testid="app-title" className="font-display font-extrabold text-lg sm:text-2xl leading-none tracking-tight text-amber-50 truncate">
            Parcheggi liberi
          </h1>
          <p data-testid="app-copyright" className="font-mono-x text-[10px] sm:text-xs uppercase tracking-wider text-amber-400/90 mt-1">
            © Copyright Teatro Torpignattara
          </p>
        </div>
        {user && (
          <div className="flex items-center gap-1">
            <NotificationsBell />
            <button
              data-testid="logout-button"
              onClick={logout}
              title="Esci"
              className="h-10 w-10 grid place-items-center rounded-full text-stone-300 hover:bg-stone-800 hover:text-white transition-colors"
            >
              <LogOut className="h-5 w-5" />
            </button>
          </div>
        )}
      </div>
      {user && <ActiveReservation />}
    </header>
  );
};
